import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const weightChangeReason: AnswerPathTreeNode = {
  path: 'weightChangeReason',
  nodeId: NodeIds.insuredWeightChangeReason,
};
